import type { FC } from 'react';

import type { IconProps } from './type';

export const DailyIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      fill="none"
      height={16}
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.62 15.098c-1.031 0-2.003-.2-2.917-.598a7.442 7.442 0 0 1-2.388-1.598 7.441 7.441 0 0 1-1.599-2.389A7.217 7.217 0 0 1 .12 7.598c0-1.03.2-2.003.597-2.916.387-.913.92-1.71 1.599-2.389A7.441 7.441 0 0 1 4.703.695 7.217 7.217 0 0 1 7.62.098c1.03 0 2.002.199 2.916.597.913.386 1.71.919 2.389 1.598a7.444 7.444 0 0 1 1.598 2.389c.398.913.597 1.885.597 2.916 0 1.03-.199 2.002-.597 2.915a7.444 7.444 0 0 1-1.598 2.39 7.442 7.442 0 0 1-2.39 1.598 7.217 7.217 0 0 1-2.915.597Zm.754-7.5V3.856h-1.51v5.235h4.496V7.598H8.374Z"
        fill="#B4BAE9"
      />
    </svg>
  );
};
